/**
 * Data Fetch
 */

// お知らせ
export function fetch_information() {
	// コンテンツを取得し、ページに表示する
	function fetchInfoPosts() {
		fetch('https://www.hanaimo.com/info/wp-json/custom/v2/post?cat_id=11&post_count=3')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-info-items');
				if (!container) return;

				data.forEach(val => {
					const dateData = new Date(val.date);

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-info-item">
              <div class="item__head">
                <div class="time">${val.date}</div>
              </div>
              <div class="item__body">
                <div class="title"><a href="${val.link}">${val.title}</a></div>
              </div>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchInfoPosts);
}

// hanaimo365
export function fetch_journal() {
	// コンテンツを取得し、ページに表示する
	function fetchJournalPosts() {
		fetch('https://www.hanaimo.com/journal/wp-json/custom/v2/post?post_count=4')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-journal-items');
				if (!container) return;

				data.forEach(val => {

          const thumb = val.media;
          let thum = "https://www.hanaimo.com/journal/wp-content/themes/hanaimo-journal/assets/images/noimage.png"; // デフォルト画像

          if ( thumb ) {
            thum = thumb;
          }

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-journal-item">
              <div class="item__head">
                <figure>
                  <img src="${thum}" alt="${val.title}" width="300" height="200">
                </figure>
              </div>
              <div class="item__body">
                <div class="title"><a href="${val.link}">${val.title}</a></div>
                <div class="time">${val.date}</div>
                ${val.term}
              </div>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchJournalPosts);
}

// voice
export function fetch_voice() {
	// コンテンツを取得し、ページに表示する
	function fetchVoicePosts() {
		fetch('https://www.hanaimo.com/voice/wp-json/custom/v2/post?post_count=4')
			.then(response => response.json())
			.then(data => {
				const container = document.querySelector('.c-voice-items');
				if (!container) return;

				data.forEach(val => {

          const thumb = val.media;
          let thum = "https://www.hanaimo.com/voice/wp-content/themes/hanaimo-voice/assets/images/noimage.png"; // デフォルト画像

          if ( thumb ) {
            thum = thumb;
          }

					// HTML構造を生成してコンテナに追加
					container.insertAdjacentHTML('beforeend', `
						<div class="c-voice-item">
              <a href="${val.link}">
                <div class="item__head">
                  <figure>
                    <img src="${thum}" alt="${val.title}" width="360" height="240">
                  </figure>
                </div>
                <div class="item__body">
                  <div class="title">${val.title}</div>
                </div>
              </a>
						</div>
					`);
				});
			})
			.catch(error => {
				console.error('Failed to fetch posts:', error);
			});
	}

	// ドキュメントの読み込みが完了したら実行
	document.addEventListener('DOMContentLoaded', fetchVoicePosts);
}

/** ***************
 * 各WPサイトの情報を取得
 * iwc-hanaimo-custom-endpointプラグインで、カスタムエンドポイントを追加
 *  ***************
 */

/**
 * 花アルバム
 */
export function fetch_data_album() {
  // コンテンツを取得し、ページに表示する
  function fetchAlbumPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/album/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

           // カテゴリの取得
           let categoryHTML = '';
           if (val.category && val.category.length > 0) {
             categoryHTML = val.category.map(catGroup =>
               // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
               catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
             ).join(', ');
           }
           // カテゴリのHTMLを条件付きで生成
           const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

           // タグの取得
           let tagHTML = '';
           if (val.tag && val.tag.length > 0) {
             tagHTML = val.tag.map(tagdataGroup =>
               // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
               tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
             ).join(', ');
           }
           // タグのHTMLを条件付きで生成
           const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

           // HTML構造を生成してコンテナに追加
           container.insertAdjacentHTML('beforeend', `
             <div class="c-data-item" id="post-${postId}">
               <a href="${postLink}">
                 <figure>
                   <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                 </figure>
                 <div class="data-body">
                   ${categoryDiv}
                   <div class="title">${postTitle}</div>
                   <div class="content">${postContent}</div>
                   ${tagDiv}
                 </div>
               </a>
             </div>
           `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-album-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-album-data-items').forEach(container => {
      fetchAlbumPosts(container);
    });
  });

}

/**
 * ブログ
 */
export function fetch_data_blog() {
  // コンテンツを取得し、ページに表示する
  function fetchBlogPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/blog/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <a href="${postLink}">
                <figure>
                  <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                </figure>
                <div class="data-body">
                  ${categoryDiv}
                  <div class="title">${postTitle}</div>
                  <div class="content">${postContent}</div>
                  ${tagDiv}
                </div>
              </a>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-blog-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-blog-data-items').forEach(container => {
      fetchBlogPosts(container);
    });
  });

}

/**
 * 文例集
 */
export function fetch_data_example() {
  // コンテンツを取得し、ページに表示する
  function fetchExamplePosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/example/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <a href="${postLink}">
                <figure>
                  <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                </figure>
                <div class="data-body">
                  ${categoryDiv}
                  <div class="title">${postTitle}</div>
                  <div class="content">${postContent}</div>
                  ${tagDiv}
                </div>
              </a>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-example-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-example-data-items').forEach(container => {
      fetchExamplePosts(container);
    });
  });

}

/**
 * 花以想の記
 */
export function fetch_data_hanaokuri() {
  // コンテンツを取得し、ページに表示する
  function fetchHanaokuriPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/hanaokuri/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

           // カテゴリの取得
           let categoryHTML = '';
           if (val.category && val.category.length > 0) {
             categoryHTML = val.category.map(catGroup =>
               // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
               catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
             ).join(', ');
           }
           // カテゴリのHTMLを条件付きで生成
           const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

           // タグの取得
           let tagHTML = '';
           if (val.tag && val.tag.length > 0) {
             tagHTML = val.tag.map(tagdataGroup =>
               // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
               tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
             ).join(', ');
           }
           // タグのHTMLを条件付きで生成
           const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

           // HTML構造を生成してコンテナに追加
           container.insertAdjacentHTML('beforeend', `
             <div class="c-data-item" id="post-${postId}">
               <a href="${postLink}">
                 <figure>
                   <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                 </figure>
                 <div class="data-body">
                   ${categoryDiv}
                   <div class="title">${postTitle}</div>
                   <div class="content">${postContent}</div>
                   ${tagDiv}
                 </div>
               </a>
             </div>
           `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-hanaokuri-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-hanaokuri-data-items').forEach(container => {
      fetchHanaokuriPosts(container);
    });
  });

}

/**
 * お知らせ
 */
export function fetch_data_info() {
  // コンテンツを取得し、ページに表示する
  function fetchInfoPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/info/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <a href="${postLink}">
                <figure>
                  <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                </figure>
                <div class="data-body">
                  ${categoryDiv}
                  <div class="title">${postTitle}</div>
                  <div class="content">${postContent}</div>
                  ${tagDiv}
                </div>
              </a>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-infomation-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-info-data-items').forEach(container => {
      fetchInfoPosts(container);
    });
  });

}

/**
 * 花贈りの豆知識
 */
export function fetch_data_journal() {
  // コンテンツを取得し、ページに表示する
  function fetchJournalPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/journal/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <a href="${postLink}">
                <figure>
                  <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                </figure>
                <div class="data-body">
                  ${categoryDiv}
                  <div class="title">${postTitle}</div>
                  <div class="content">${postContent}</div>
                  ${tagDiv}
                </div>
              </a>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-journal-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-journal-data-items').forEach(container => {
      fetchJournalPosts(container);
    });
  });

}

/**
 * お客様の声
 */
export function fetch_data_voice() {
  // コンテンツを取得し、ページに表示する
  function fetchVoicePosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/voice/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }

          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <a href="${postLink}">
                <figure>
                  <img src="${postImage}" alt="Thumbnail" width="300" height="300">
                </figure>
                <div class="data-body">
                  ${categoryDiv}
                  <div class="title">${postTitle}</div>
                  <div class="content">${postContent}</div>
                  ${tagDiv}
                </div>
              </a>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-voice-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-voice-data-items').forEach(container => {
      fetchVoicePosts(container);
    });
  });

}

/**
 * よくある質問
 */
export function fetch_data_faq() {
  // コンテンツを取得し、ページに表示する
  function fetchFaqPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/faq/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <div class="c-data-item" id="post-${postId}">
              <div class="title">
                <a href="${postLink}" target="_blank">${postTitle}</a>
              </div>
            </div>
          `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-faq-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-faq-data-items').forEach(container => {
      fetchFaqPosts(container);
    });
  });

}

/**
 * よくある質問（コンテンツ込み）
 */
const GLightbox = window.GLightbox;
let lightbox;
function initOrReloadGLightbox() {
  if (lightbox) {
    lightbox.reload();
  } else {
    lightbox = GLightbox({
      selector: '.js-lightbox',
      touchNavigation: true,
    });
  }
}
export function fetch_data_faq_contents() {

  // コンテンツを取得し、ページに表示する
  function fetchFaqContentsPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');
    const category = container.getAttribute('data-category');
    const tag = container.getAttribute('data-tag');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/faq/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);
    if (category) params.append('category', category);
    if (tag) params.append('tag', tag);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postTitle = val.title;
          const postLink = val.link;
          const postContent = val.content;
          // ② <img> をモーダル用に加工
          const enhancedContent = postContent.replace(
            /<img([^>]*?)src="([^"]+)"([^>]*?)>/g,
            (_, pre, src, post) => {
              // WordPress が出力した 768x768 などをフルサイズ URL に戻す
              const full = src.replace(/-\d+x\d+(?=\.\.\w{3,4}$)/, '');
              return `<img${pre}src="${src}" data-src="${full}" data-type="image" class="js-lightbox"${post}>`;
            }
          );
          const postImage = val.media || "https://hanaimo.itembox.design/item/noimage.png"; // デフォルト画像

          // カテゴリの取得
          let categoryHTML = '';
          if (val.category && val.category.length > 0) {
            categoryHTML = val.category.map(catGroup =>
              // catGroup.map(cat => `<a href="${cat.link}">${cat.name}</a>`).join(' ')
              catGroup.map(cat => `<span>${cat.name}</span>`).join(' ')
            ).join(', ');
          }
          // カテゴリのHTMLを条件付きで生成
          const categoryDiv = categoryHTML ? `<div class="category">${categoryHTML}</div>` : '';

          // タグの取得
          let tagHTML = '';
          if (val.tag && val.tag.length > 0) {
            tagHTML = val.tag.map(tagdataGroup =>
              // tagdataGroup.map(tagdata => `<a href="${tagdata.link}">${tagdata.name}</a>`).join(' ')
              tagdataGroup.map(tagdata => `<span>${tagdata.name}</span>`).join(' ')
            ).join(', ');
          }
          // タグのHTMLを条件付きで生成
          const tagDiv = tagHTML ? `<div class="tag">${tagHTML}</div>` : '';

          // HTML構造を生成してコンテナに追加
          container.insertAdjacentHTML('beforeend', `
            <details class="c-folding js-details p-faq" id="faq-${postId}">
              <summary class="js-summary">
                <h3 class="title">${postTitle}</h3>
              </summary>
              <div class="js-content">
                <div class="c-folding__inner">
                ${enhancedContent}
                </div>
              </div>
            </details>
          `);

				});
        // ③ 挿入が完了したタイミングで Lightbox を有効化
        initOrReloadGLightbox();
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-faq-contents-items` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-faq-contents-data-items').forEach(container => {
      fetchFaqContentsPosts(container);
    });
  });

}

/** ***************
 * WPサイトの情報を取得
 * iwc-hanaimo-d-customプラグインで、カスタムエンドポイントを追加
 *  ***************
 */

/**
 * D
 */
export function fetch_data_d() {
  // コンテンツを取得し、ページに表示する
  function fetchDPosts(container) {
    if (!container) return;

    // data属性の値を取得
    const postType = container.getAttribute('data-posttype');
    const postCount = container.getAttribute('data-postcount');
    const postId = container.getAttribute('data-postid');

    // APIのURLを作成
    let apiUrl = 'https://www.hanaimo.com/d/wp-json/custom/v2/post';
    let params = new URLSearchParams();

    // カンマ区切りのデータをそのままURLパラメータとして追加
    if (postType) params.append('post_type', postType);
    if (postCount) params.append('post_count', postCount);
    if (postId) params.append('postid', postId);

    // パラメータが存在する場合のみURLに追加
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }

    // console.log(`Fetching data for container: ${container.className}, URL: ${apiUrl}`);

		fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log(`Data received for ${container.className}:`, data);
        container.innerHTML = ''; // 既存の内容をクリア

        if (!Array.isArray(data) || data.length === 0) {
          container.innerHTML = `<p>No posts found.</p>`;
          return;
        }

        // HTMLエンティティをデコードする関数
        // function decodeHTML(html) {
        //   const txt = document.createElement('textarea');
        //   txt.innerHTML = html;
        //   return txt.value;
        // }

        data.forEach(val => {
          // ID、タイトル、リンク、コンテンツ、メディアURLを取得
          const postId = val.id;
          const postType = val.pt;
          const postTitle = val.title;
          const postContent = val.content;

           // HTML構造を生成してコンテナに追加
           container.insertAdjacentHTML('beforeend', `
            <div class="c-d-data-content" id="post-${postId}" data-posttype="${postType}">
              ${postContent}
            </div>
           `);
          //  container.insertAdjacentHTML('beforeend', `
          //   <div class="c-data-content" id="post-${postId}">
          //     ${decodeHTML(postContent)}
          //   </div>
          // `);

				});
			})
			.catch(error => {
        console.error(`Failed to fetch posts for ${container.className}:`, error);
        container.innerHTML = `<p>Error loading posts.</p>`;
			});
	}

  // ページ内のすべての `.c-d-data-item` を処理する
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-d-data-item').forEach(container => {
      fetchDPosts(container);
    });
  });

}
